export const shareConfig = {
  id: 'shareVideoWrapper',
  alignment: 'center',
  color: 'social',
  enabled: true,
  font_size: 16,
  labels: null,
  language: 'en',
  networks: ['linkedin', 'facebook', 'twitter', 'email'],
  padding: 12,
  radius: 4,
  show_total: false,
  size: 40,
  image: 'https://bit.ly/2CMhCMC',
  description: 'custom text',
  title: 'custom title',
  message: 'custom email text',
  subject: 'custom email subject',
  username: 'custom twitter handle'
};

export const videoUrls = {
  1: 'https://www.youtube.com/embed/knr-UrKl6Ks',
  2: 'https://www.youtube.com/embed/5fzN8v26v28',
  3: 'https://www.youtube.com/embed/FOw1Ggc393s'
};